import type { FaireProductEntity } from "../../entity_types/product";

export const p_nk6nkza8fe: FaireProductEntity = {
  token: "p_nk6nkza8fe",
  type: "product",
  name: "Book Lover Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/6a4c4d1aeac6771c4f8842ee39e659dd54aff06ad230fe30cfe34fa080ae5547.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/15677290ecb10a50588d1309052f0853349123fc98058696a90c2d50e98530a3.jpeg",
    "https://cdn.faire.com/fastly/a91edbe8619722ebc8b2ec09f0a6e38fd9177bb01b6504020648913f1aa8c790.jpeg",
    "https://cdn.faire.com/fastly/80033f9d87a006c585d26df918c16d62d1c1bce707f41bf6fb8ae5466667e540.png",
    "https://cdn.faire.com/fastly/27fc7237698e9377f181757441a8a76edd26c06d08016b2bb12f8fbfaa8323df.webp",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:51.315Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
